import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-jornada-de-nomina';

/**
 * GET Tipos Jornadas Nominas
 * @returns {Promise<object[]>}
 */
export const getTiposJornadasNominas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo Jornada Nomina
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoJornadaNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo Jornada Nomina
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoJornadaNomina = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo Jornada Nomina
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoJornadaNomina = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo Jornada Nomina
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoJornadaNomina = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
